<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">Справочники</div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directorys-tabs">
                  <ul class="tabs">
                    <li :class="{active: pageNumber == 0}" data-page="0" @click="pageNumber = 0">Услуги и цены</li>
                    <li :class="{active: pageNumber == 1}" data-page="1" @click="pageNumber = 1">Районы и области</li>
                    <li :class="{active: pageNumber == 2}" data-page="2" @click="pageNumber = 2">Другие справочники</li>
                  </ul>
                  <div>
                    <div class="directorys-list" v-show="pageNumber == 0">
                      <router-link to="/directories/trucking-categories" style="color:black">
                        <div class="item">
                          <div class="name"><i class="fa fa-folder-o"></i>Грузоперевозки
                          </div>
                        </div>
                      </router-link>
                      <router-link to="/directories/mover-categories" style="color:black">
                        <div class="item">
                          <div class="name"><i class="fa fa-folder-o"></i>Грузчики</div>
                        </div>
                      </router-link>
                      <router-link to="/directories/furniture-categories" style="color:black">
                        <div class="item">
                          <div class="name"><i class="fa fa-folder-o"></i>Сборка мебели</div>
                        </div>
                      </router-link>
                      <router-link to="/directories/petrol-categories" style="color:black">
                        <div class="item">
                          <div class="name"><i class="fa fa-folder-o"></i>ГСМ</div>
                        </div>
                      </router-link>
                      <router-link to="/directories/downtime-categories" style="color:black">
                        <div class="item">
                          <div class="name"><i class="fa fa-folder-o"></i>Сутки простоя</div>
                        </div>
                      </router-link>
                      <router-link to="/directories/garbage-removal" style="color:black">
                        <div class="item">
                          <div class="name"><i class="fa fa-folder-o"></i>Вывоз мусора</div>
                        </div>
                      </router-link>
                      <router-link to="/directories/additional-categories" style="color:black">
                        <div class="item">
                          <div class="name"><i class="fa fa-folder-o"></i>Доп. услуги</div>
                        </div>
                      </router-link>
                    </div>
                    <div class="directorys-list" v-show="pageNumber == 1">
                      <router-link to="/directories/districts" style="color:black">
                        <div class="item">
                          <div class="name"><i class="fa fa-folder-o"></i>Районы</div>
                        </div>
                      </router-link>
                      <router-link to="/directories/regions" style="color:black">
                      <div class="item">
                        <div class="name"><i class="fa fa-folder-o"></i>Области</div>
                      </div>
                      </router-link>
                      <router-link to="/directories/leeway" style="color:black">
                        <div class="item">
                          <div class="name"><i class="fa fa-folder-o"></i>Запас времени</div>
                        </div>
                      </router-link>
                    </div>
                    <div class="directorys-list" v-show="pageNumber == 2">
                      <div class="item">
                        <div class="name"><i class="fa fa-folder-o"></i>Максимально допустимая задолженность</div>
                      </div>
                      <div class="item">
                        <div class="name"><i class="fa fa-folder-o"></i>Пользователи</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'

    export default {
  name: 'Directories',
  components: {
    MenuDispatcher,
    HeaderDispatcher
  },

  data () {
    return {
      pageNumber: 0
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    this.pageNumber = this.$store.getters.directoryTabNumber
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  }
}
</script>
